/**
 * Analytics types for GenAI Studio v2
 */

// Screen action types
export enum AiGenScreenAction {
  GENERATE = 'generate',
  GENERATE_CLICK = 'generate_click',
  RETRY = 'retry',
  DISMISS_ERROR = 'dismiss_error',
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
  CANCEL = 'cancel',
  EDIT = 'edit',
  BACK = 'back',
  CLICK = 'click',
  SHARE = 'share',
  DELETE = 'delete',
  REPORT = 'report',
  REUSE_TEMPLATE = 'reuse_template',
  TRENDING_ITEM_CLICK = 'trending_item_click',
  CHIP_CLICK = 'chip_click',
  SEE_ALL = 'see_all',
}

// Screen type values
export enum ScreenType {
  GENERATOR = 'generator_screen',
  CHOOSER = 'chooser_screen',
  HISTORY = 'history',
  PREVIEW = 'preview_screen',
}

// Item types for click action
export enum ClickItem {
  Category = 'category',
  Effect = 'effect',
}

// Settings object for analytics
export interface AnalyticsSettings {
  category: string;
  id?: string;
}

// Extended settings for failure cases (error fields required)
export interface AnalyticsSettingsWithError extends AnalyticsSettings {
  error_type: string;
  error_message: string;
}
